import { useCallback } from 'react';
import LogRocket from 'logrocket';

const logRocketFreightRegistrationSubmittedEventName = 'FREIGHT_REGISTRATION_SUBMITTED';

export const useTrackFreightRegistrationSubmitted = (): (() => void) => {
  return useCallback(() => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightRegistrationSubmittedEventName, { env: environment });
  }, []);
};
